import type { EditAsideColor } from '@nodeTypeConfig/configTypes';
import { patchNodeAction } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import jQuery from 'jquery';
import 'jquery-minicolors/jquery.minicolors.css';
import 'jquery-minicolors/jquery.minicolors.min';
import { debounce, set } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';

const AsideColor: React.FC<{
  config: EditAsideColor;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();

  const initialValue = useInitialValue(config.property);

  const change = debounce((color: string) => {
    dispatch(
      patchNodeAction(getResourceKey(editHref), set({}, config.property, color), true, null, false),
    );
  }, 500);

  const inputRef = useRef(null);
  useEffect(() => {
    const ref = jQuery(inputRef.current);
    if (!readonly && ref) {
      ref.minicolors({ position: 'bottom', theme: 'bootstrap', change });
    }
  }, [change, readonly]);

  return (
    <>
      {config.label && <label className="control-label control-label-inline">{config.label}</label>}
      <input
        id="color-input"
        className="form-control"
        type="text"
        defaultValue={initialValue}
        ref={inputRef}
        disabled={readonly}
      />
    </>
  );
};

AsideColor.displayName = 'AsideColor';

export default AsideColor;

AsideColor.propTypes = {
  config: any,
  readonly: any,
};
